import React from 'react';
import { User } from '@tassomutuo-backoffice/types';
import { Tooltip, Typography } from '@mui/material';

interface IProps {
  user: User;
}

const TeamUserBqConsultantPerformance = ({ user }: IProps) => {
  const bqWeeklyPerformance = user.bqWeeklyPerformance;

  return (
    <Tooltip title={bqWeeklyPerformance?.perf_overall?.toFixed(2) + ' %'}>
      <Typography fontSize={14}>{bqWeeklyPerformance?.rating}</Typography>
    </Tooltip>
  );
};

export default TeamUserBqConsultantPerformance;
